export default [
  {
    path: "/persalinan",
    component: () => import("@/pages/persalinan/persalinan-list.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/persalinan/import",
    component: () => import("@/pages/persalinan/persalinan-import.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
];
